import { SelectField } from '~/common/components';
import { useI18n } from '~/common/context';
import { IFormConfigurationContext } from '@wyz/types';
import { Icon } from '@wyz/ui';
import * as React from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { DIAMETERS, DIAMETER_OPERATORS } from '~/purchase/schemas';
import { PRICING_POLICY_OPERATOR_LABEL_LOOKUP } from '~/purchase/translators';
import { IDiameter, IQuoteServiceMountingStepForm } from '~/purchase/types';

type DiameterFieldProps = {
  refinementIndex: number;
  baseName: string;
  onRemoveRow: (idx: number) => void;
  mode: IFormConfigurationContext['mode'];
};

const DiameterField: React.FC<DiameterFieldProps> = ({
  refinementIndex,
  baseName,
  onRemoveRow,
  mode,
}) => {
  const { t } = useI18n();
  const methods = useFormContext<IQuoteServiceMountingStepForm>();

  const watchedDiameter = useWatch({
    control: methods.control,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    name: `${baseName}.diameter` as any,
  }) as IDiameter;

  const hasSelectedBetweenOperator =
    watchedDiameter?.operator === DIAMETER_OPERATORS.BETWEEN;
  const hasSelectedLowerThanOperator =
    watchedDiameter?.operator === DIAMETER_OPERATORS.LOWER_THAN_OR_EQUAL;

  return (
    <div className='d-flex space-x-2'>
      <>
        <div style={{ width: '20%' }}>
          <SelectField
            name={
              hasSelectedLowerThanOperator
                ? `${baseName}.diameter.to`
                : `${baseName}.diameter.from`
            }
            options={DIAMETERS.map((diameter) => ({
              label: diameter.toString(),
              value: diameter,
            }))}
            size='sm'
            feedbackType='tooltip'
            formGroupClassName={'w-100'}
          />
        </div>
        <div className='flex-grow-1'>
          <SelectField
            name={`${baseName}.diameter.operator`}
            options={Object.values(DIAMETER_OPERATORS).map((operator) => ({
              label: t(PRICING_POLICY_OPERATOR_LABEL_LOOKUP[operator]),
              value: operator,
            }))}
            size='sm'
            feedbackType='tooltip'
            formGroupClassName={'w-100'}
          />
        </div>
        {hasSelectedBetweenOperator && (
          <div style={{ width: '20%' }}>
            <SelectField
              name={`${baseName}.diameter.to`}
              options={DIAMETERS.map((diameter) => ({
                label: diameter.toString(),
                value: diameter,
              }))}
              size='sm'
              feedbackType='tooltip'
              formGroupClassName={'w-100'}
            />
          </div>
        )}
      </>
      {mode === 'WRITE' && (
        <div className='g-col-3 d-flex align-items-center space-x-2'>
          <Icon
            icon='close'
            size='xs'
            onClick={() => onRemoveRow(refinementIndex)}
            className='cursor-pointer'
            id={`remove-diameter-${refinementIndex}`}
          />
        </div>
      )}
    </div>
  );
};

export default DiameterField;
